import { environment } from '../../../environments/environment';

export const analyticsConfig = {
  measurementId: environment.analytics.measurementId,
  enabled: environment.analytics.enabled,
  debug: environment.analytics.debug,
  environmentName: environment.environmentName,
  productionFlag: environment.environmentName === 'production',
  config: {
    enhanced_measurement: true,
    session_timeout: 1800,
    scroll_events: true,
    outbound_links: true,
    file_downloads: true,
    site_search: false,
    debug_mode: environment.analytics.debug,
    send_page_view: true
  }
};
